import { GET_COUPON_LIST_REQUESTED, GET_APPLY_COUPON_REQUESTED, GET_APPLY_COUPON_RENTAL_REQUESTED,GET_APPLY_COUPON_CLEAR,GET_APPLY_COUPON_RENTAL_CLEAR } from 'resources/actionTypes';

export function getCouponList(userCouponList) {
  const data = {
    userCouponList: userCouponList,
  };
  return {
    type: GET_COUPON_LIST_REQUESTED,
    payload: data,
  };
}

export function postCoupon(postCouponData,toggle) {
    const data = {
        postCouponData: postCouponData,
        setCardModel: toggle,
    };
    return {
      type: GET_APPLY_COUPON_REQUESTED,
      payload: data,
    };
  }

  export function postCouponRental(postCouponRentalData,toggle) {
    const data = {
        postCouponRentalData: postCouponRentalData,
        setCardModel: toggle,
    };
    return {
      type: GET_APPLY_COUPON_RENTAL_REQUESTED,
      payload: data,
    };
  }

  export function clearApplyCoupon(){
    return {
      type:GET_APPLY_COUPON_CLEAR,
    }
  }

  export function clearApplyCouponRental(){
    return {
      type:GET_APPLY_COUPON_RENTAL_CLEAR,
    }
  }
